const AUTH_SESSION_KEYS = ['token', 'refreshToken', 'user'] as const;

/** Opens an internal page in an independent tab initialized with this tab's account. */
export const openAuthenticatedTab = (url: string): Window | null => {
  const opened = window.open('', '_blank');
  if (!opened) return null;

  for (const key of AUTH_SESSION_KEYS) {
    const value = sessionStorage.getItem(key);
    if (value === null) opened.sessionStorage.removeItem(key);
    else opened.sessionStorage.setItem(key, value);
  }
  opened.opener = null;
  opened.location.replace(url);
  return opened;
};
